import {
    AggregateFunctions,
    AggregateQueryInterval,
    ApiQuery,
    SortDirections,
} from "~/modules/filters/types";
import { AssetTimeseriesColumns, AssetTimeseriesGroupBy } from "./types";
import { API_QUERY_EXAMPLES } from "./components/AssetTimeseriesList/consts";

// // // //

/**
 * DEFAULT_ASSET_TIMESERIES_QUERY
 * Default ApiQuery for AssetTimeseries API
 */
export const DEFAULT_ASSET_TIMESERIES_QUERY: ApiQuery = {
    filter: API_QUERY_EXAMPLES[0].query.filter,
    aggregate: {
        groupBy: AssetTimeseriesGroupBy.asset,
        aggregateFunction: AggregateFunctions.Sum,
        interval: AggregateQueryInterval.day,
    },
    sort: {
        direction: SortDirections.asc,
        field: AssetTimeseriesColumns.date,
    },
    pagination: {
        page: 1,
        perPage: 25,
    },
};
